export default __webpack_public_path__ + "static/media/skippedmeal_6@3x.8dcc3734.jpg";